/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response containing the Google OAuth2 authorization URL
 * @export
 * @interface GmailAuthUrlResponse
 */
export interface GmailAuthUrlResponse {
    /**
     * The Google OAuth2 authorization URL to redirect the user to
     * @type {string}
     * @memberof GmailAuthUrlResponse
     */
    url: string;
}

/**
 * Check if a given object implements the GmailAuthUrlResponse interface.
 */
export function instanceOfGmailAuthUrlResponse(value: object): value is GmailAuthUrlResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function GmailAuthUrlResponseFromJSON(json: any): GmailAuthUrlResponse {
    return GmailAuthUrlResponseFromJSONTyped(json, false);
}

export function GmailAuthUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GmailAuthUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function GmailAuthUrlResponseToJSON(json: any): GmailAuthUrlResponse {
    return GmailAuthUrlResponseToJSONTyped(json, false);
}

export function GmailAuthUrlResponseToJSONTyped(value?: GmailAuthUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

